const items = document.querySelectorAll(".js-redirect");

[...items].forEach((item) => {
  item.addEventListener("change", () => {
    window.location = item.value;
  });
});
